import {authServerInstance, gatewayInstance} from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addCustomerConsignee = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/customerConsignee`,
    data,
  );
  return response;
};

export const updateCustomerConsignee = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/customerConsignee`,
    data,
  );
  return response;
};

export const searchCustomerConsignee = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/customerConsignee/search`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getCustomerConsigneesByCustomerId = async (id) => {
  try {
    console.log(`getUserCustomerByUserId data`);
    console.log(id);
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/customerConsignee/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};